
export enum AtivoInativoEnum {
  A = 'A', I = 'I'
}
